import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';

import { CxFormsModule } from '@forms';
import { UiDialogModule, DxPopupModule } from '@ui-dialog';
import { UserModule } from '@user';

import { UpgradeService } from './upgrade.service';
import { UpgradeComponent } from './upgrade.component';
import { ParameterWindowComponent } from './parameter-window.component';
import { BacNetParameterWindowComponent } from './bac-net.parameter-window.component';
import { UpgradeConfigurationComponent } from './upgrade-configuration.component';
import { PrivilegesModule } from '@privileges';
import { PlantIdToNamePipe, PlantsModule } from '@plants';
import { BatchUpgradeScheduleListComponent } from './batch-upgrade/batch-upgrade-schedule-list.component';
import { RouterModule } from '@angular/router';
import { BatchUpgradeConfigurationComponent } from './batch-upgrade/batch-upgrade-configuration.component';
import { BatchUpgradeStatusService } from './batch-upgrade/batch-upgrade-status.service';
import { ToolsModule } from '@tools';
import { BatchUpgradeListComponent } from './batch-upgrade/batch-upgrade-list.component';
import { BatchUpgradeDetailsComponent } from './batch-upgrade/batch-upgrade-details.component';
import { UiMessagesModule } from '@ui-messages';
import { BatchUpgradeService } from './batch-upgrade/batch-upgrade.service';
import { ConverterModule } from '@converter';
import { TitleManager, TitleManagerModule } from '@title-manager';
import { BatchIdToNamePipe } from './batch-upgrade/batch-uprade.id-to-name.pipe';
import { MappingWindowComponent } from './mapping-window.component';


@NgModule({
    imports: [
        FormsModule,
        CxFormsModule,
        CommonModule,
        UiDialogModule,
        UserModule,
        PrivilegesModule,
        DxPopupModule,
        PlantsModule,
        RouterModule,
        ToolsModule,
        UiMessagesModule,
        ConverterModule,
        TitleManagerModule
    ],
    declarations: [
        UpgradeComponent,
        ParameterWindowComponent,
        BacNetParameterWindowComponent,
        UpgradeConfigurationComponent,
        BatchUpgradeScheduleListComponent,
        BatchUpgradeConfigurationComponent,
        BatchUpgradeListComponent,
        BatchUpgradeDetailsComponent,
        MappingWindowComponent
    ],
    exports: [
        UpgradeComponent,
        ParameterWindowComponent,
        BacNetParameterWindowComponent,
        UpgradeConfigurationComponent,
        BatchUpgradeScheduleListComponent,
        BatchUpgradeConfigurationComponent,
        BatchUpgradeListComponent,
        BatchUpgradeDetailsComponent,
        MappingWindowComponent
    ],
    providers: [
        UpgradeService,
        BatchUpgradeStatusService,
        BatchUpgradeService,
        BatchIdToNamePipe
    ],
    schemas : [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class UpgradeModule {
    constructor(private titleManager: TitleManager) {
        this.titleManager.register(BatchIdToNamePipe);
    }
}

export {
    UpgradeComponent,
    UpgradeService,
    ParameterWindowComponent,
    BacNetParameterWindowComponent,
    UpgradeConfigurationComponent,
    BatchUpgradeScheduleListComponent,
    BatchUpgradeConfigurationComponent,
    BatchUpgradeStatusService,
    BatchUpgradeListComponent,
    BatchUpgradeDetailsComponent,
    PlantIdToNamePipe,
    MappingWindowComponent
};
